'use strict';

var arrayUtil = require('../util/array-util');
var nocUtil = require('../util/noc-util');

module.exports = /*@ngInject*/ ["NmsConfigResourceService", "$q", function SqiFactory(NmsConfigResourceService, $q) {
    "use strict";
    var factory = {};

    factory.getSlaById = function (id, projectId) {
        return factory.getSlaByProperty("id", id, projectId);
    };

    factory.createProjectSpecficSqis = function (statistics, invalidValue, projectId) {

        return factory.fetchProjectSpecificSqis(projectId, function (projectSqiList) {
            var selectedStatistics = [];
            angular.forEach(projectSqiList, function (sqiEntry) {
                var id = sqiEntry.id;
                var statistic = arrayUtil.getFirstInList(statistics, 'sqiId', id);
                statistic = nocUtil.extendWithSQIMetaData(statistic, sqiEntry, invalidValue);
                selectedStatistics.push(statistic);
            });
            return selectedStatistics;
        });

    };

    factory.fetchProjectSpecificSqis = function (projectId, callback) {
        var deferred = $q.defer();
        NmsConfigResourceService.requestConfig(projectId).getSqis().$promise.then(function (projectSqiList) {
            deferred.resolve(callback(projectSqiList));
        });
        return deferred.promise;
    };

    factory.fetchProjectSpecificConfiguration = function (projectId, callback) {
        var deferred = $q.defer();
        NmsConfigResourceService.requestConfig(projectId).getComplete().$promise.then(function (projectConfig) {
            deferred.resolve(callback(projectConfig));
        });
        return deferred.promise;
    };
    return factory;
}];